export const CookieKey = {
  /**
   * Name of the key for the stored authentication token
   * Must stay in sync with NewAppCookiesKey from the old app
   */
  authenticationApiToken: 'nf-api-token',
  /**
   * Lowercase 2 characters language code
   * Must stay in sync with NewAppCookiesKey from the old app
   */
  appLanguage: 'nf-app-language'
};
